export const isOwnSession = (post, expertId) => {
  return post?.group?.expert?.id === expertId;
};
